import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    BenefitDto, BenefitPaginator,
    CreateBenefitDto,
    UpdateBenefitDto, QueryBenefitDto, SearchBenefitDto
} from "../models/benefit.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetBenefit(options?: QueryBenefitDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.BENEFIT.GET;
    const request = (options: QueryBenefitDto) => API.ProcessingCompanyAPI.getBenefit(options);

    const { data, isLoading, error, refetch } = useQuery<BenefitPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch }
}

export function useGetBenefitSearch() {

    return useMutation(
        (options?: SearchBenefitDto) => API.ProcessingCompanyAPI.getBenefitSearch(options),
        {
            onSuccess: (response,) => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )

}

export function useGetBenefitById(id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.BENEFIT.DETAIL;
    const request = API.ProcessingCompanyAPI.getBenefitById(id);

    const {data, isLoading, error} = useQuery<{ data:BenefitDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateBenefit() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload}: {payload: CreateBenefitDto}) => API.ProcessingCompanyAPI.createBenefit(payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.BENEFIT.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateBenefit() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, id}: {payload: UpdateBenefitDto, id: number}) => API.ProcessingCompanyAPI.updateBenefit(id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.BENEFIT.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteBenefit() {

    return useMutation(
        ({ id }: { id: number }) => API.ProcessingCompanyAPI.deleteBenefit(id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useUploadBenefit() {

    return useMutation(
            ({ payload, companyId }: { payload: FormData; companyId: number }) =>
                API.ProcessingCompanyAPI.uploadBenefits(companyId, payload),
            {
                onSuccess: () => {
                },
                onError: API.Handlers.onErrorHandler,
                onSettled: () => {},
            }
        );
}